import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

/**
 * tailwind-merge must know Graphite Desk's custom scales, otherwise it treats
 * `text-h1` (size) and `text-ink` (colour) as the same group and drops one.
 */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ['meta', 'label', 'table', 'body', 'h3', 'h2', 'h1', 'figure'],
      color: [
        'canvas',
        'surface',
        'surface-muted',
        'sidebar',
        'sidebar-active',
        'ink',
        'ink-secondary',
        'ink-muted',
        'border',
        'border-strong',
        'primary',
        'primary-hover',
        'primary-foreground',
        'accent',
        'accent-hover',
        'accent-subtle',
        'positive',
        'warning',
        'warning-edge',
        'positive-subtle',
        'row-hover',
        'row-selected',
        'negative',
        'negative-subtle',
        'info',
        'info-subtle',
        'focus',
        'scrim',
        'white',
      ],
      radius: ['sm', 'md', 'full'],
      shadow: ['overlay'],
      spacing: [
        'sidebar',
        'sidebar-collapsed',
        'header',
        'context',
        'drawer',
        'drawer-wide',
        'dialog',
        'dialog-form',
        'form',
        'record',
        'queue-list',
      ],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
